import { render, staticRenderFns } from "./ExerciseSkill.vue?vue&type=template&id=f01db4ac&scoped=true&"
import script from "./ExerciseSkill.vue?vue&type=script&lang=js&"
export * from "./ExerciseSkill.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseSkill.vue?vue&type=style&index=0&id=f01db4ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01db4ac",
  null
  
)

export default component.exports